import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row w-full p-3 gap-3 border-b border-gray-lp-1000" }
const _hoisted_2 = { class: "flex font-semibold text-14px" }
const _hoisted_3 = { class: "flex flex-grow" }
const _hoisted_4 = { class: "text-14px text-right" }
const _hoisted_5 = { class: "flex flex-col gap-4 p-3 text-14px" }
const _hoisted_6 = { class: "flex flex-row w-full gap-2 items-center" }
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", {
  width: "14",
  height: "16",
  viewBox: "0 0 14 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M3.66659 7.66602C3.66659 7.20578 4.03968 6.83268 4.49992 6.83268H9.49992C9.96016 6.83268 10.3333 7.20578 10.3333 7.66602C10.3333 8.12625 9.96016 8.49935 9.49992 8.49935H4.49992C4.03968 8.49935 3.66659 8.12625 3.66659 7.66602Z",
    fill: "#4D4D4D"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M4.49992 10.166C4.03968 10.166 3.66659 10.5391 3.66659 10.9993C3.66659 11.4596 4.03968 11.8327 4.49992 11.8327H7.83325C8.29349 11.8327 8.66658 11.4596 8.66658 10.9993C8.66658 10.5391 8.29349 10.166 7.83325 10.166H4.49992Z",
    fill: "#4D4D4D"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.91674 0.999349C9.53665 0.493329 8.93151 0.166016 8.24992 0.166016H5.74992C5.06833 0.166016 4.46319 0.493329 4.0831 0.999349H2.83325C1.45254 0.999349 0.333252 2.11864 0.333252 3.49935V13.4993C0.333252 14.8801 1.45254 15.9993 2.83325 15.9993H11.1666C12.5473 15.9993 13.6666 14.8801 13.6666 13.4993V3.49935C13.6666 2.11864 12.5473 0.999349 11.1666 0.999349H9.91674ZM5.33325 2.24935C5.33325 2.01923 5.5198 1.83268 5.74992 1.83268H8.24992C8.48004 1.83268 8.66658 2.01923 8.66658 2.24935C8.66658 2.47947 8.48004 2.66602 8.24992 2.66602H5.74992C5.5198 2.66602 5.33325 2.47947 5.33325 2.24935ZM3.70826 2.66602H2.83325C2.37301 2.66602 1.99992 3.03911 1.99992 3.49935V13.4993C1.99992 13.9596 2.37301 14.3327 2.83325 14.3327H11.1666C11.6268 14.3327 11.9999 13.9596 11.9999 13.4993V3.49935C11.9999 3.03911 11.6268 2.66602 11.1666 2.66602H10.2916C10.0985 3.61695 9.25782 4.33268 8.24992 4.33268H5.74992C4.74202 4.33268 3.90129 3.61695 3.70826 2.66602Z",
    fill: "#4D4D4D"
  })
], -1)
const _hoisted_8 = { class: "flex flex-grow text-14px" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "flex" }, null, -1)
const _hoisted_10 = { class: "text-14px text-right" }
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  width: "14",
  height: "17",
  viewBox: "0 0 14 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.99992 0.166016C4.69873 0.166016 2.83325 2.0315 2.83325 4.33268C2.83325 6.63387 4.69873 8.49935 6.99992 8.49935C9.3011 8.49935 11.1666 6.63387 11.1666 4.33268C11.1666 2.0315 9.3011 0.166016 6.99992 0.166016ZM4.49992 4.33268C4.49992 2.95197 5.61921 1.83268 6.99992 1.83268C8.38063 1.83268 9.49992 2.95197 9.49992 4.33268C9.49992 5.71339 8.38063 6.83268 6.99992 6.83268C5.61921 6.83268 4.49992 5.71339 4.49992 4.33268Z",
    fill: "#4D4D4D"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.99992 9.33268C3.31802 9.33268 0.333252 12.3175 0.333252 15.9993C0.333252 16.4596 0.706348 16.8327 1.16659 16.8327H12.8333C13.2935 16.8327 13.6666 16.4596 13.6666 15.9993C13.6666 12.3175 10.6818 9.33268 6.99992 9.33268ZM6.99992 10.9993C9.47742 10.9993 11.5341 12.8013 11.9308 15.166H2.06905C2.46578 12.8013 4.52242 10.9993 6.99992 10.9993Z",
    fill: "#4D4D4D"
  })
], -1)
const _hoisted_12 = { class: "flex flex-row gap-2 border border-gray-lp-1300 border-dashed rounded p-2 items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("svg", {
    width: "16",
    height: "15",
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M1.78624 7.5C0.0712534 9.215 0.0712518 11.9988 1.78624 13.7138C3.50123 15.4287 6.28498 15.4287 7.99997 13.7138L11.7282 9.9855C12.7535 8.96023 12.7535 7.28252 11.7282 6.25725C10.7029 5.23198 9.02524 5.23198 7.99997 6.25725L4.27174 9.9855C3.92998 10.3273 3.92998 10.8865 4.27173 11.2283C4.61349 11.57 5.17273 11.57 5.51448 11.2283L9.24272 7.5C9.58448 7.15824 10.1437 7.15824 10.4855 7.5C10.8272 7.84176 10.8272 8.40099 10.4855 8.74275L6.75723 12.471C5.73196 13.4963 4.05425 13.4963 3.02899 12.471C2.00372 11.4457 2.00372 9.76802 3.02899 8.74275L9.24272 2.529C10.268 1.50373 11.9457 1.50373 12.971 2.529C13.5923 3.15037 13.8657 4.04516 13.6855 4.90887C13.5923 5.38733 13.8968 5.85336 14.3753 5.94656C14.8537 6.03977 15.3198 5.7353 15.413 5.25684C15.705 3.80903 15.2514 2.32394 14.2137 1.28625C12.4987 -0.428749 9.71496 -0.428749 7.99998 1.28625L1.78624 7.5Z",
      fill: "#B82025"
    })
  ])
], -1)
const _hoisted_14 = { class: "flex flex-grow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    rounded: "xl",
    isShadow: false
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.data.id), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode("span", {
            class: ["capitalize text-center rounded-full text-12px xxl:text-14px px-2 whitespace-nowrap", {
            'bg-green-lp-300 text-green-lp-200':
              _ctx.data.status.toLowerCase() === 'success',
            'bg-yellow-lp-200 text-yellow-lp-100':
              _ctx.data.status.toLowerCase() === 'partially' ||
              _ctx.data.status.toLowerCase() === 'waiting',
            'bg-red-300 text-red-lp-100':
              _ctx.data.status.toLowerCase() === 'failed',
            'bg-gray-lp-200 text-black-lp-300':
              _ctx.data.status.toLowerCase() === 'uploading'
          }]
          }, _toDisplayString(_ctx.statusString + " " + _ctx.data.dataProcessed + "/" + _ctx.data.totalData), 3)
        ]),
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.formatDate(_ctx.data.createdAt)), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.data.activityName), 1),
          _hoisted_9,
          _createVNode("div", _hoisted_10, _toDisplayString(_ctx.data.createdBy || "-"), 1),
          _hoisted_11
        ]),
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode("div", _hoisted_14, _toDisplayString(_ctx.fileName(_ctx.data)), 1),
          _createVNode("div", {
            class: "font-semibold cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
          }, _toDisplayString(_ctx.$t("managementCustomer.bulk.download")), 1)
        ])
      ])
    ]),
    _: 1
  }))
}